import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import {Navigate} from '@ngxs/router-plugin';
import {AuthState} from '../../states/auth/auth.state';
import {Settings} from '../../../../conf/settings.base';

@Injectable({
  providedIn: 'root',
})
export class VerifiedGuard {
  constructor(private store: Store, private settings: Settings) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.settings.ACCOUNT_EMAIL_VERIFICATION !== 'mandatory') {
      return true;
    }

    return this.store.select(AuthState.getUser).pipe(
      filter(x => !!x),
      map(user => {
        const isAuthenticated = this.store.selectSnapshot(AuthState.isAuthenticated);
        const isVerified = this.store.selectSnapshot(AuthState.isVerified);

        if (isAuthenticated && !isVerified) {
          this.store.dispatch(new Navigate(['/auth/not-verified/']));
          return false;
        }

        return true;
      })
    );
  }
}
